import { ReactNode } from 'react';

import cn from 'classnames';

type Props = { children: ReactNode; className?: string };
const Italic = ({ children, className }: Props) => {
    return <span className={cn('italic', className)}>{children}</span>;
};

export default Italic;
